<template>
  <div @contextmenu="selectComponentDEV($event, schema.model)" :class="[getSelectedDEV && 'dev-selected-component']">
    <v-card>
      <v-data-table
        v-bind="schema.attributesTable.dataTable"
        v-model="selected"
        :headers="schema.headers"
        :items="schema.itemsTable"
        :search="search"
      >
        <template v-slot:top v-if="schema.attributesTable.showToolbar">
          <v-toolbar flat>
            <v-btn icon text @click="openDialogExport()" v-if="schema.attributesTable.showExport" v-tooltip.bottom="'Exportar dados'">
              <v-icon>cloud_download</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-text-field
              v-if="schema.attributesTable.showSearch"
              v-model="search"
              append-icon="search"
              label="Pesquisar"
              single-line
              hide-details
            ></v-text-field>
          </v-toolbar>
        </template>
      </v-data-table>
    </v-card>

    <i4proDialogExport
      :dialog="showDialogExport"
      @closeDialogExport="closeDialogExport"
      :headers="schema.headers"
      :model="schema.itemsTable"
      :mode="formOptions.mode"
      :page="formOptions.page"
    />
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';

export default {
  mixins: [abstractField, devComponentMixin],

  components: {
    i4proDialogExport: () => import('@/components/dialogs/i4pro-dialog-export')
  },

  data: () => ({
    search: '',
    showDialogExport: false,
    selected: []
  }),

  methods: {
    closeDialogExport() {
      this.showDialogExport = false;
    },

    openDialogExport() {
      this.showDialogExport = true;
    }
  },

  watch: {
    selected(newValue) {
      this.value = newValue;
    }
  }
};
</script>
